import React from 'react';
import LegalDoc from '../components/LegalDoc';

const sections = [
  {
    heading: '1. About This Website & Who We Are',
    paragraphs: [
      'InternetTVService ("we", "us", "our") is a DBA of CyberCloud LLC and operates as an independent Authorized Dealer for Internet and TV services. We help consumers compare, choose, and order Internet, Cable TV, Wi-Fi, and Wireless services from third-party providers.',
      'We are not an internet or TV service provider, and we are not affiliated with, endorsed by, sponsored by, or operated by any service provider. This website is not the official website of any provider. All company names, brand names, trademarks, and logos referenced on this site are the property of their respective owners and are used for identification purposes only.',
    ],
  },
  {
    heading: '2. Acceptance of Terms',
    paragraphs: [
      'By accessing or using this website, contacting us, or submitting a request, you agree to these Terms & Conditions and our Privacy Policy. If you do not agree, please do not use this website or our services.',
    ],
  },
  {
    heading: '3. Our Services',
    paragraphs: [
      'We provide sales assistance, plan comparison, and enrollment support. When you place an order or request service through us, the actual internet, TV, or wireless service is delivered, billed, and supported by the underlying provider under that provider’s own terms, contracts, and policies.',
    ],
    items: [
      'We help you identify available plans based on your address and needs.',
      'We assist with enrollment, scheduling, and general questions.',
      'The provider remains solely responsible for network performance, installation, billing, and ongoing service.',
    ],
  },
  {
    heading: '4. Pricing, Availability & Promotional Offers',
    paragraphs: [
      'Plans, prices, speeds, channel lineups, equipment, and availability vary by location and by provider, and are subject to change at any time without notice. Any pricing or offers mentioned are provided by the underlying providers and are for general information only.',
    ],
    items: [
      'Advertised prices may be promotional and apply for a limited time, after which standard rates apply.',
      'Prices generally exclude taxes, surcharges, government fees, installation, and equipment charges unless clearly stated.',
      'Offers may require eligibility checks, credit approval, service agreements, autopay, or bundling.',
      'Final pricing and terms are confirmed by the provider before your service begins.',
    ],
  },
  {
    heading: '5. How We Are Compensated (Affiliate Disclosure)',
    paragraphs: [
      'We may receive a commission, referral fee, or other compensation from providers or marketing partners when you order a service through us. This does not change the price you pay and does not influence the honest, needs-based recommendations we make. Our goal is to help you find a plan that fits your location, budget, and requirements.',
    ],
  },
  {
    heading: '6. Billing, Cancellations & Refunds',
    paragraphs: [
      'Because the actual internet, TV, or wireless service is provided and billed by the underlying provider, all billing, payments, cancellations, returns of equipment, and refunds are handled directly by that provider under its own terms and policies. We do not bill you for the monthly service itself.',
      'If you paid us any separate fee for an optional service we provide directly and wish to request a refund, contact us at contact@internettvservice.com and we will review your request. Provider cancellation windows, early-termination fees, and equipment-return requirements are set by the provider — please review your provider agreement.',
    ],
  },
  {
    heading: '7. No Guarantee & Accuracy of Information',
    paragraphs: [
      'We work to keep information on this site accurate and up to date, but we make no warranties that content is complete, current, or error-free. We do not guarantee service availability, specific speeds, or uninterrupted service, as these depend on the provider and your location.',
    ],
  },
  {
    heading: '8. Contact & Communication Consent (TCPA)',
    paragraphs: [
      'When you submit a form or otherwise provide your phone number, you expressly consent to receive calls and text messages from us and our authorized partners — including by automatic telephone dialing systems (autodialer) and prerecorded or artificial voice messages — at the number you provide, regarding the services you requested. Consent is not a condition of any purchase. Message frequency may vary, and message and data rates may apply. You can opt out of texts at any time by replying "STOP", and you may contact us to stop other communications.',
    ],
  },
  {
    heading: '9. Intellectual Property',
    paragraphs: [
      'All original content on this website — including text, graphics, layout, and design — is owned by or licensed to InternetTVService and may not be copied or reused without permission. Third-party trademarks remain the property of their respective owners.',
    ],
  },
  {
    heading: '10. Limitation of Liability',
    paragraphs: [
      'The actual internet, TV, Wi-Fi, and wireless services are owned and operated by third-party providers. We are not responsible for the quality, speed, reliability, installation, outages, billing, or any acts or omissions of those providers — these are the responsibility of the provider under your agreement with them.',
      'To the fullest extent permitted by law, InternetTVService is not liable for any indirect, incidental, or consequential damages arising from your use of this website or from services provided by third-party providers. Your use of the website is at your own risk.',
    ],
  },
  {
    heading: '11. Third-Party Links',
    paragraphs: [
      'This website may contain links to third-party websites. We are not responsible for the content, policies, or practices of those sites. Accessing them is at your own discretion.',
    ],
  },
  {
    heading: '12. Changes to These Terms',
    paragraphs: [
      'We may update these Terms & Conditions from time to time. Changes are effective when posted on this page. Continued use of the website after changes are posted constitutes acceptance of the updated terms.',
    ],
  },
  {
    heading: '13. Contact Us',
    paragraphs: [
      'Questions about these Terms? Email contact@internettvservice.com or call +1 (888) 880-2585. InternetTVService is a DBA of CyberCloud LLC. Address: 13800 Coppermine Rd, Herndon, VA 20171.',
    ],
  },
];

const TermsConditions = () => (
  <LegalDoc
    eyebrow="Legal"
    title="Terms &"
    titleAccent="Conditions"
    intro="Please read these terms carefully. They explain who we are, how our service works, and the conditions for using this website."
    updated="Last updated: 2026"
    sections={sections}
  />
);

export default TermsConditions;
